<template>
    <div>
      <br>
      <table class="styled-table">
        <tr>
          <td style="width: 31%; text-align: left;">
            <el-link v-if="!isLogin" native-type="button" type="warning" plain @click="goOwnerlogin();">オーナーログイン</el-link>
            <el-link v-if="isLogin" native-type="button" type="warning" plain @click="goOwnerUpdate();">オーナー情報修正</el-link>
          </td>
          <td style="width: 38%; text-align: center;">
            <el-link v-if="isLogin" native-type="button" type="warning" plain @click="goMyPets()">マイペット</el-link>
          </td>
          <td style="width: 31%; text-align: right;">
            <el-link native-type="button" type="warning" plain @click="goCareRules()">飼育ルール</el-link>
          </td>
        </tr>
      </table>
      <br>
      <el-form :inline="true" :model="form" >
        <div v-if="infoType !== '2'">
          <h1>掲示板</h1>
          <Keijiban v-if="infoType !== '2'" :keijibanList="keijibanList" :loading="loading" /> 
        </div>
        <div v-if="!loading && this.keijibanList && keijibanList.length > 0">
          <el-pagination v-if="infoType == '1'"
            class="custom-pagination"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
          <table v-if="infoType == '3'" class="styled-table">
            <tr><td><el-link native-type="button" type="warning" plain @click="initPagination('1', 10, 1)">More...</el-link></td></tr><br>
          </table>
        </div>
        <div v-if="loading"><br><br><br></div>
        <div v-if="infoType !== '1'">
          <h1>News</h1>
          <Pet :petList="petList" :loading="loading" @img-click="handleImgClick" />
        </div>
        <div v-if="!loading && this.petList && petList.length > 0">
          <el-pagination v-if="infoType == '2'"
            class="custom-pagination"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-sizes="[12, 24, 48, 96]"
            :page-size="pageSize"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
          <table v-if="infoType == '3'" class="styled-table">
            <tr><td><el-link native-type="button" type="warning" plain @click="initPagination('2', 12, 1)">More...</el-link></td></tr><br>
          </table>
        </div>
      </el-form>
      <el-dialog :visible.sync="imgDialogVisible" width="80vw" class="img-dialog" :show-close="true" top="5vh">
        <img :src="imgDialogUrl" class="dialog-img" />
      </el-dialog>
    </div>
  </template>
  
  <script>
  import request from '@/utils/request';
  import Cookies from 'js-cookie';
  import Keijiban from '@/components/Keijiban.vue';
  import Pet from '@/components/Pet.vue';
  export default {
    name: 'Board',
    inject: ['manshonId'],
    components: {
      Keijiban,
      Pet,
    },
    data() {
      return {
        manshonId: this.manshonId(),
        loading: false,  // ローディング中
        infoType:'3',    // 1:掲示板 2:ペット 3:全て
        kokaiFlg:'',     // 1:公開しない 2:マンション内公開 3:一般公開
        currentPage:0,   // 現在のページ
        pageSize:0,      // 1ページ当たりの件数
        total:0,         // 総件数
        keijibanList: [],// 掲示板情報 
        petList: [],     // ペット情報
        form: {},        // フォーム
        imgDialogVisible: false,
        imgDialogUrl: ''
      };
    },
    computed: {
      // クッキーのトークンの有無でログイン状態を確認
      isLogin() {
        return !!Cookies.get('token');
      }
    },
    created() {
      this.fetchBoardData();    
    },
    methods: {
      // ページネーション初期化
      initPagination(infoType, pageSize, currentPage) {
        this.infoType = infoType;
        this.pageSize = pageSize
        this.handlePageChange(currentPage) 
      },
      // ページ変更
      handlePageChange(val) {
        this.currentPage = val
        this.fetchBoardData()
      },
      // 1ページあたりの表示件数変更
      handleSizeChange(val) {
        this.pageSize = val
        this.currentPage = 1
        this.fetchBoardData()
      },
      // 掲示板データ取得
      fetchBoardData() {
        this.loading = true;
        const params = {
          infoType: this.infoType,
          manshonId: this.manshonId,
          kokaiFlg:this.kokaiFlg,
          page: this.currentPage.toString(),
          limit: this.pageSize.toString(),
        };
        request('getBoardInfo', params).then((res) => {
          this.keijibanList = res.keijibanInfo?.keijibanList;
          this.petList = res.petInfo?.petList;
          this.total = { '1': res.keijibanInfo?.total, '2': res.petInfo?.total }[this.infoType];
        }).finally(() => {
          this.loading = false;
        });    
      },
      // ログインへ遷移
      goOwnerlogin() {
        this.$router.push({
          path: "/login",
          query: { manshonId: this.manshonId }
        }).catch(() => {});
      },
      // オーナー情報修正へ遷移
      goOwnerUpdate() {
        this.$router.push({
          path: "/ownerUpdate",
          query: { manshonId: this.manshonId }
        }).catch(() => {});
      },
      // オーナー・マイページへ遷移
      goMyPets() {
        this.$router.push({
          path: '/myPets',
        }).catch(() => {});
      },
      // 飼育ルールへ遷移
      goCareRules() {
        this.$router.push({
          path: "/care-rules",
          query: { manshonId: this.manshonId }
        }).catch(() => {});
      },
      handleImgClick(url) {
        this.imgDialogUrl = url;
        this.imgDialogVisible = true;
      },
    },
  };
  </script>
  
  <style lang="less">
    html, body {
      overflow-x: hidden;
      width: 100%;
    }
    h1 {
      padding-top: 10em;                 /*上部の余白*/
      padding: 0.25em 0.5em;             /*上下 左右の余白*/
      color: #494949;                  /*文字色*/
      background: transparent;           /*背景透明に*/
      border-left: solid 5px #7db4e6;  /*左枠線*/
    }
    .styled-table {
      font-size: 15px;                   /* フォントサイズ */
      line-height: 1.5em;                /* 行の高さ */
      width: 100%;                       /* テーブル幅 */
      max-width: 100%;                   /* 最大幅制限 */
      border: 0;                         /* テーブル枠線なし */
      table-layout: fixed;               /* 固定レイアウト */
      box-sizing: border-box;            /* ボックスモデル */
      word-wrap: break-word;             /* 長文折り返し */
      word-break: break-all;             /* 文字での折り返し */
      .el-link {
      display: inline-block;
      white-space: nowrap;               /* リンクテキスト折り返しなし */
      }
      td {
      padding: 10px;
      vertical-align: top;
      overflow-wrap: break-word;         /* 折り返し方式 */
      word-break: break-word;            /* 緩やかな折り返し */
      &.nowrap {
        white-space: nowrap;
      }
      }
    }
    .styled-table td.nowrap {
      white-space: nowrap;
    }
    .custom-pagination {
      display: flex;                     /* 横並び */
      flex-wrap: wrap;                   /* 折り返し可能 */
      white-space: nowrap;               /* ボタン折り返しなし */
      overflow: hidden;                  /* スクロールバー非表示 */
      justify-content: center;           /* 中央揃え */ 
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      padding: 0 10px;                   /* 内側余白 */
      margin: 0;                         /* 外側余白なし */
    }
    
    /* スマホ用（600px以下）のページネーション調整 */
    @media screen and (max-width: 600px) {
      .custom-pagination {
      flex-wrap: wrap !important;      /* 折り返し強制 */
      }
      .el-pagination .el-pagination__sizes,
      .el-pagination .el-pagination__jump {
      display: none !important;        /* サイズ選択とジャンプ機能を非表示 */
      }
      .custom-pagination .el-pagination__total {
      width: 100%;                     /* 「総件数」全幅表示 */
      text-align: center;              /* 「総件数」中央揃え */
      margin-bottom: 5px;              /* 「総件数」下部余白 */
      }
      .custom-pagination .el-pagination__prev,
      .custom-pagination .el-pagination__pager,
      .custom-pagination .el-pagination__next {
      flex-shrink: 0;                  /* 「前へ」「次へ」折り返しなし */
      }
    }
    @media screen and (max-width: 768px) {
      .styled-table {
      td {
        padding: 5px;                  /* 余白縮小 */
        font-size: 13px;               /* 文字サイズ縮小 */
        .el-link {
        font-size: 13px;               /* リンク文字サイズ統一 */
        }
      }
      }
    }
    .img-dialog {
      text-align: center;
    }
    .dialog-img {
      display: block;
      width: 100%;
      height: auto;
      max-height: 80vh;
      object-fit: contain;
      margin: 0 auto;
    }
   </style>